import { 
  CreateCreditAccountData,
  CreateCreditAccountsResponse,
  CreditAccount,
  CreditAccountsAPI,
  UpdateCreditAccountRequest 
} from "../../../api/credit_accounts";
import { MessageResponse } from "../../../api/common";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Stakeholder } from '../../../api/stakeholders'

export const addCreditAccounts = createAsyncThunk<
  CreateCreditAccountsResponse,
  {case_id: string; credit_accounts: CreateCreditAccountData[]; stakeholders?: Stakeholder[]},
  { rejectValue: string }
>(
  "creditAccounts/add",
  async (params, { rejectWithValue }) => {
    try {
      return await CreditAccountsAPI.add(params.case_id, params.credit_accounts, params.stakeholders);
    } catch {
      return rejectWithValue("Failed to add credit accounts");
    }
  },
);

export const updateCreditAccount = createAsyncThunk<
  MessageResponse,
  {case_id: string; account_number: string, request : UpdateCreditAccountRequest},
  { rejectValue: string }
>(
  "creditAccounts/update",
  async (params, { rejectWithValue }) => {
    try {
      return await CreditAccountsAPI.update(params.case_id, params.account_number, params.request);
    } catch {
      return rejectWithValue("Failed to update credit account");
    }
  },
);